/**
 * Product Card LOP - JavaScript para funcionalidad de swatches
 * Versión: 3.0.0
 * Autor: LOP Development Team
 */

(function() {
  'use strict';

  // Configuración
  const LOP_CONFIG = {
    maxSwatches: 5,
    navigationDelay: 300,
    loadingClass: 'loading',
    errorClass: 'error',
    hoverClass: 'hover'
  };

  // Clases CSS
  const LOP_CLASSES = {
    swatchesContainer: 'LOP-product-card-swatches-container',
    swatchItem: 'LOP-product-card-swatch-item',
    swatchLink: 'LOP-product-card-swatch-link',
    swatchImage: 'LOP-product-card-swatch-image'
  };

  /**
   * Clase principal para manejar Product Card LOP
   */
  class ProductCardLOP {
    constructor() {
      this.initialized = false;
      this.init();
    }

    /**
     * Inicializar la funcionalidad
     */
    init() {
      if (this.initialized) return;
      
      
      // Inicializar swatches existentes
      this.initSwatches();
      
      // Observar cambios en el DOM para nuevos swatches
      this.observeDOM();
      
      // Verificar swatches después de la carga
      this.checkSwatchesAfterLoad();
      
      // Verificar y ocultar swatches fallback inmediatamente
      this.hideInvalidFallbackSwatches();
      
      // Cargar datos de productos faltantes después de un delay
      setTimeout(() => {
        this.loadMissingProductData();
        // Ocultar duplicados DESPUÉS de cargar todos los datos
        this.hideDuplicateSwatches();
      }, 1000);
      
      this.initialized = true;
    }

    /**
     * Inicializar swatches existentes
     */
    initSwatches() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      
      swatches.forEach((swatch, index) => {
        this.setupSwatch(swatch, index);
      });
    }

    /**
     * Configurar un swatch individual
     */
    setupSwatch(swatch, index) {
      if (!swatch.dataset.productHandle) {
        console.warn(`Product Card LOP: Swatch ${index} sin product handle`);
        return;
      }

      // Remover eventos existentes para evitar duplicados
      const newSwatch = swatch.cloneNode(true);
      swatch.parentNode.replaceChild(newSwatch, swatch);
      
      // Configurar eventos en el nuevo swatch
      this.addSwatchEvents(newSwatch, index);
      
    }

    /**
     * Añadir eventos a un swatch
     */
    addSwatchEvents(swatch, index) {
      const link = swatch.querySelector(`.${LOP_CLASSES.swatchLink}`);
      
      if (link) {
        // Evento de click
        link.addEventListener('click', (e) => {
          this.handleSwatchClick(e, swatch);
        });
        
        // Eventos de hover
        swatch.addEventListener('mouseenter', () => {
          this.handleSwatchHover(swatch, true);
        });
        
        swatch.addEventListener('mouseleave', () => {
          this.handleSwatchHover(swatch, false);
        });
        
        // Evento de focus para accesibilidad
        swatch.addEventListener('focus', () => {
          this.handleSwatchFocus(swatch);
        });
      }
    }

    /**
     * Manejar click en swatch
     */
    handleSwatchClick(e, swatch) {
      e.preventDefault();
      e.stopPropagation();
      
      const productHandle = swatch.dataset.productHandle;
      if (!productHandle) {
        console.error('Product Card LOP: No se encontró product handle');
        return;
      }


      // Añadir clase de carga
      swatch.classList.add(LOP_CONFIG.loadingClass);

      // Navegar al producto después del delay
      setTimeout(() => {
        try {
          window.location.href = `/products/${productHandle}`;
        } catch (error) {
          console.error('Product Card LOP: Error al navegar:', error);
          swatch.classList.remove(LOP_CONFIG.loadingClass);
          swatch.classList.add(LOP_CONFIG.errorClass);
        }
      }, LOP_CONFIG.navigationDelay);
    }

    /**
     * Manejar hover en swatch
     */
    handleSwatchHover(swatch, isEntering) {
      if (isEntering) {
        swatch.classList.add(LOP_CONFIG.hoverClass);
        
        // Aquí podrías implementar la lógica para cambiar la imagen del product card
        const productHandle = swatch.dataset.productHandle;
        if (productHandle) {
          // Buscar el product card padre
          const productCard = swatch.closest('product-card');
          if (productCard) {
            // Aquí podrías cambiar la imagen del product card
          }
        }
      } else {
        swatch.classList.remove(LOP_CONFIG.hoverClass);
      }
    }

    /**
     * Manejar focus en swatch
     */
    handleSwatchFocus(swatch) {
      const productHandle = swatch.dataset.productHandle;
      if (productHandle) {
      }
    }

    /**
     * Observar cambios en el DOM
     */
    observeDOM() {
      const observer = new MutationObserver((mutations) => {
        let shouldCheck = false;
        
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.classList && node.classList.contains(LOP_CLASSES.swatchItem)) {
                  shouldCheck = true;
                } else if (node.querySelector && node.querySelector(`.${LOP_CLASSES.swatchItem}`)) {
                  shouldCheck = true;
                }
              }
            });
          }
        });
        
        if (shouldCheck) {
          setTimeout(() => {
            this.checkForNewSwatches();
          }, 100);
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    /**
     * Verificar nuevos swatches
     */
    checkForNewSwatches() {
      const allSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const initializedSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}[data-lop-initialized]`);
      
      if (allSwatches.length > initializedSwatches.length) {
        
        allSwatches.forEach((swatch, index) => {
          if (!swatch.hasAttribute('data-lop-initialized')) {
            this.setupSwatch(swatch, index);
            swatch.setAttribute('data-lop-initialized', 'true');
          }
        });
      }
    }

    /**
     * Verificar swatches después de la carga
     */
    checkSwatchesAfterLoad() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => {
            this.checkForNewSwatches();
          }, 500);
        });
      } else {
        setTimeout(() => {
          this.checkForNewSwatches();
        }, 500);
      }
    }

    /**
     * Verificar que todos los swatches estén funcionando
     */
    verifyAllSwatches() {
      const allSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      
      allSwatches.forEach((swatch, index) => {
        if (swatch.dataset.productHandle) {
          // Asegurar que el swatch sea clickeable
          swatch.style.pointerEvents = 'auto';
          swatch.style.cursor = 'pointer';
          
          // Verificar que tenga los atributos necesarios
          if (!swatch.hasAttribute('data-lop-verified')) {
            swatch.setAttribute('data-lop-verified', 'true');
          }
        } else {
          console.warn(`Product Card LOP: Swatch ${index} sin product handle`);
        }
      });
      
      return allSwatches.length;
    }

    /**
     * Función de utilidad para debug
     */
    debug() {
      const allSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      return {
        config: LOP_CONFIG,
        classes: LOP_CLASSES,
        totalSwatches: allSwatches.length,
        swatches: Array.from(allSwatches).map((swatch, index) => ({
          index,
          handle: swatch.dataset.productHandle,
          color: swatch.dataset.productColor,
          tooltip: swatch.dataset.tooltip,
          isCurrent: swatch.dataset.isCurrentProduct
        }))
      };
    }

    /**
     * Verificar productos relacionados en un product card específico
     */
    debugProductCard(productCard) {
      if (!productCard) {
        return { error: 'No se proporcionó product card' };
      }

      const swatches = productCard.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const productTitle = productCard.querySelector('.product-card-title')?.textContent || 'Sin título';
      
      return {
        productTitle,
        totalSwatches: swatches.length,
        swatches: Array.from(swatches).map((swatch, index) => ({
          index: index + 1,
          handle: swatch.dataset.productHandle,
          color: swatch.dataset.productColor,
          tooltip: swatch.dataset.tooltip,
          url: swatch.dataset.productHandle ? `/products/${swatch.dataset.productHandle}` : null
        }))
      };
    }

    /**
     * Verificar todos los product cards en la página
     */
    debugAllProductCards() {
      const productCards = document.querySelectorAll('product-card');
      
      return {
        total: productCards.length,
        cards: Array.from(productCards).map((card, index) => {
        const title = card.querySelector('.product-card-title')?.textContent || 'Sin título';
        const swatches = card.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
        
          return {
            index: index + 1,
            title,
            totalSwatches: swatches.length,
            swatchHandles: Array.from(swatches).map(s => s.dataset.productHandle)
          };
        })
      };
    }

    /**
     * Verificar si los productos del agrupador existen
     */
    debugAgrupadorProducts(agrupadorString) {
      if (!agrupadorString) {
        return { error: 'No se proporcionó agrupador' };
      }

      try {
        // Parsear el JSON del agrupador
        const agrupador = JSON.parse(agrupadorString);
        console.log(`Product Card LOP: Agrupador parseado - ${agrupador.length} productos`);
        
        agrupador.forEach((handle, index) => {
          console.log(`Producto ${index + 1}: ${handle}`);
          
          // Verificar si el producto existe haciendo una petición
          fetch(`/products/${handle}.js`)
            .then(response => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error(`Producto no encontrado: ${handle}`);
              }
            })
            .then(product => {
              console.log(`  ✓ ${handle} - ${product.title}`);
            })
            .catch(error => {
              console.log(`  ✗ ${handle} - ${error.message}`);
            });
        });
      } catch (error) {
        console.error('Product Card LOP: Error parseando agrupador:', error);
      }
    }

    /**
     * Cargar datos de productos dinámicamente
     */
    loadProductData(handle) {
      // Limpiar el handle de caracteres extra y verificar si está concatenado
      let cleanHandle = handle.trim();
      
      // Verificar si el handle está concatenado (muy largo o contiene caracteres extra)
      if (cleanHandle.length > 50 || cleanHandle.includes('remera-') && cleanHandle.includes('buzo-')) {
        console.log(`Product Card LOP: Handle sospechoso detectado: ${cleanHandle}`);
        
        // Intentar separar handles concatenados
        const possibleHandles = cleanHandle.split(/(?=remera-|buzo-|zapatillas-|calzado-)/);
        if (possibleHandles.length > 1) {
          console.log(`Product Card LOP: Intentando separar handle: ${possibleHandles.join(' y ')}`);
          // Usar el primer handle válido
          cleanHandle = possibleHandles[0].trim();
        }
      }
      
      console.log(`Product Card LOP: Handle original: ${handle}, limpio: ${cleanHandle}`);
      console.log(`Product Card LOP: Intentando cargar desde URL: /products/${cleanHandle}.js`);
      
      return fetch(`/products/${cleanHandle}.js`)
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error(`Producto no encontrado: ${cleanHandle}`);
          }
        })
        .catch(error => {
          console.error(`Product Card LOP: Error cargando ${cleanHandle}:`, error);
          return null;
        });
    }

    /**
     * Actualizar swatch con datos del producto
     */
    updateSwatchWithProductData(swatch, productData) {
      if (!productData) return;

      // Actualizar imagen si está disponible
      if (productData.featured_image) {
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        if (swatchImage) {
          // Si es un div (fallback), convertirlo a img
          if (swatchImage.tagName === 'DIV') {
            const newImg = document.createElement('img');
            newImg.src = productData.featured_image;
            newImg.alt = productData.title;
            newImg.className = 'LOP-product-card-swatch-image';
            newImg.loading = 'lazy';
            swatchImage.parentNode.replaceChild(newImg, swatchImage);
          } else {
            // Si ya es una img, actualizar src
            swatchImage.src = productData.featured_image;
            swatchImage.alt = productData.title;
          }
        }
      }

      // Actualizar tooltip
      if (productData.title) {
        swatch.dataset.tooltip = productData.title;
      }

      // Actualizar color si está disponible
      if (productData.options && productData.options.length > 0) {
        const firstOption = productData.options[0];
        if (firstOption.values && firstOption.values.length > 0) {
          swatch.dataset.productColor = firstOption.values[0];
        }
      }

      // Marcar como cargado exitosamente
      swatch.classList.add('LOP-swatch-loaded');
      swatch.classList.remove('LOP-product-card-swatch-fallback');

    }

    /**
     * Ocultar swatch fallback cuando no tiene imagen válida
     */
    hideFallbackSwatch(swatch) {
      if (!swatch) return;
      
      // Añadir clase para ocultar el swatch
      swatch.classList.add('LOP-swatch-hidden');
      swatch.style.display = 'none';
      
      // Remover eventos para evitar interacciones
      swatch.style.pointerEvents = 'none';
      swatch.style.cursor = 'default';
      
    }

    /**
     * Mostrar swatch válido cuando se confirma que tiene imagen
     */
    showValidSwatch(swatch) {
      if (!swatch) return;
      
      // Remover clases de ocultación
      swatch.classList.remove('LOP-swatch-hidden');
      swatch.style.display = '';
      
      // Restaurar eventos
      swatch.style.pointerEvents = 'auto';
      swatch.style.cursor = 'pointer';
      
    }

    /**
     * Ocultar swatches fallback inválidos inmediatamente
     */
    hideInvalidFallbackSwatches() {
      
      const fallbackSwatches = document.querySelectorAll('.LOP-product-card-swatch-fallback');
      let hiddenCount = 0;
      
      fallbackSwatches.forEach((swatch) => {
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        // Verificar si es un swatch de carga (gris con texto)
        if (swatchImage && swatchImage.classList.contains('LOP-product-card-swatch-loading')) {
          // Verificar si tiene el atributo data-needs-loading
          if (swatch.dataset.needsLoading === 'true') {
            this.hideFallbackSwatch(swatch);
            hiddenCount++;
          }
        }
      });
      
    }

    /**
     * Ocultar solo swatches duplicados DENTRO de cada tarjeta de producto (no global)
     * Cada tarjeta mantiene sus propios swatches independientemente de otras tarjetas
     */
    hideDuplicateSwatches() {
      // Procesar cada tarjeta de producto independientemente
      const productCards = document.querySelectorAll('product-card, .product-card');
      let totalHiddenCount = 0;
      
      productCards.forEach(card => {
        const seenHandles = new Set();
        const swatches = card.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
        
        swatches.forEach(swatch => {
          const swatchHandle = swatch.dataset.productHandle;
          if (!swatchHandle) return;
          
          // Si ya vimos este handle EN ESTA TARJETA, ocultar este swatch (es un duplicado)
          if (seenHandles.has(swatchHandle)) {
            swatch.style.display = 'none';
            swatch.classList.add('LOP-swatch-duplicate-hidden');
            totalHiddenCount++;
            return;
          }
          
          // Marcar este handle como visto para esta tarjeta
          seenHandles.add(swatchHandle);
        });
      });
      
    }

    /**
     * Cargar datos de productos para swatches que no están en all_products
     */
    loadMissingProductData() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      
      let loadedCount = 0;
      let hiddenCount = 0;
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        if (handle) {
          // Verificar si el swatch tiene datos básicos
          const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
          const hasImage = swatchImage && swatchImage.src && !swatchImage.src.includes('placeholder');
          const hasText = swatchImage && swatchImage.textContent && swatchImage.textContent.includes('Ver');
          
          // Verificar si es un swatch fallback (gris con texto)
          const isFallback = swatch.classList.contains('LOP-product-card-swatch-fallback') || 
                           (swatchImage && swatchImage.classList.contains('LOP-product-card-swatch-loading'));
          
          if (isFallback || !hasImage || hasText) {
            
            // Cargar datos del producto
            this.loadProductData(handle).then(productData => {
              if (productData && productData.available && productData.featured_image) {
                this.updateSwatchWithProductData(swatch, productData);
                this.showValidSwatch(swatch);
                loadedCount++;
              } else {
                // Mantener oculto (ya está oculto por defecto)
                hiddenCount++;
              }
            }).catch(error => {
              // Mantener oculto (ya está oculto por defecto)
              hiddenCount++;
            });
          }
        }
      });
      
    }

    /**
     * Verificar estado del fallback y swatches
     */
    debugFallbackStatus() {
      console.log('Product Card LOP: Verificando estado del fallback...');
      
      const productCards = document.querySelectorAll('product-card');
      let totalCards = 0;
      let cardsWithAgrupador = 0;
      let cardsWithSwatches = 0;
      let cardsWithFallback = 0;
      
      productCards.forEach((card, index) => {
        const title = card.querySelector('.product-card-title')?.textContent || 'Sin título';
        const swatches = card.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
        const debugInfo = card.querySelector('[style*="background: #f0f0f0"]');
        
        totalCards++;
        
        if (debugInfo) {
          cardsWithAgrupador++;
          
          if (swatches.length > 0) {
            cardsWithSwatches++;
            
            // Verificar si son swatches de fallback
            const fallbackSwatches = card.querySelectorAll('.LOP-product-card-swatch-item[data-product-color="Variante"]');
            if (fallbackSwatches.length > 0) {
              cardsWithFallback++;
              console.log(`  Card ${index + 1}: "${title}" - ${swatches.length} swatches (${fallbackSwatches.length} fallback)`);
            } else {
              console.log(`  Card ${index + 1}: "${title}" - ${swatches.length} swatches (normales)`);
            }
          } else {
            console.log(`  Card ${index + 1}: "${title}" - 0 swatches`);
          }
        } else {
          console.log(`  Card ${index + 1}: "${title}" - Sin agrupador`);
        }
      });
      
      console.log(`Product Card LOP: Resumen:`);
      console.log(`  Total cards: ${totalCards}`);
      console.log(`  Cards con agrupador: ${cardsWithAgrupador}`);
      console.log(`  Cards con swatches: ${cardsWithSwatches}`);
      console.log(`  Cards con fallback: ${cardsWithFallback}`);
      
      return {
        totalCards,
        cardsWithAgrupador,
        cardsWithSwatches,
        cardsWithFallback
      };
    }

    /**
     * Verificar estado actual de los swatches
     */
    checkCurrentSwatchStatus() {
      console.log('Product Card LOP: Verificando estado actual de swatches...');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let fallbackSwatches = 0;
      let normalSwatches = 0;
      let emptySwatches = 0;
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        if (swatchImage) {
          if (swatchImage.tagName === 'DIV' && swatchImage.textContent.includes('Ver')) {
            fallbackSwatches++;
            console.log(`  Swatch ${index + 1}: ${handle} - FALLBACK (necesita carga)`);
          } else if (swatchImage.tagName === 'IMG' && swatchImage.src) {
            normalSwatches++;
            console.log(`  Swatch ${index + 1}: ${handle} - NORMAL (con imagen)`);
          } else {
            emptySwatches++;
            console.log(`  Swatch ${index + 1}: ${handle} - VACÍO`);
          }
        } else {
          emptySwatches++;
          console.log(`  Swatch ${index + 1}: ${handle} - SIN IMAGEN`);
        }
      });
      
      console.log(`Product Card LOP: Resumen de swatches:`);
      console.log(`  Total: ${swatches.length}`);
      console.log(`  Fallback (necesitan carga): ${fallbackSwatches}`);
      console.log(`  Normales (con imagen): ${normalSwatches}`);
      console.log(`  Vacíos: ${emptySwatches}`);
      
      return {
        total: swatches.length,
        fallback: fallbackSwatches,
        normal: normalSwatches,
        empty: emptySwatches
      };
    }

    /**
     * Forzar carga de datos para todos los swatches de fallback
     */
    forceLoadAllFallbackSwatches() {
      console.log('Product Card LOP: Forzando carga de todos los swatches de fallback...');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let loadedCount = 0;
      let hiddenCount = 0;
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        if (handle && swatchImage && swatchImage.tagName === 'DIV' && swatchImage.textContent.includes('Ver')) {
          console.log(`Product Card LOP: Cargando datos forzados para ${handle}`);
          
          this.loadProductData(handle).then(productData => {
            if (productData && productData.available && productData.featured_image) {
              console.log(`Product Card LOP: Datos cargados exitosamente para ${handle} - ${productData.title}`);
              this.updateSwatchWithProductData(swatch, productData);
              this.showValidSwatch(swatch);
              loadedCount++;
            } else {
              console.log(`Product Card LOP: Producto ${handle} no disponible o sin imagen, manteniendo oculto`);
              // Mantener oculto (ya está oculto por defecto)
              hiddenCount++;
            }
          }).catch(error => {
            console.log(`Product Card LOP: Error cargando ${handle}, manteniendo oculto:`, error);
            // Mantener oculto (ya está oculto por defecto)
            hiddenCount++;
          });
        }
      });
      
      console.log(`Product Card LOP: Iniciada carga forzada de ${loadedCount} productos, ocultados ${hiddenCount} swatches`);
      return { loaded: loadedCount, hidden: hiddenCount };
    }

    /**
     * Verificar formato de metafields y handles
     */
    debugMetafieldFormat() {
      console.log('🔍 ===== DEBUG LOP HANDLES =====');
      
      // Obtener información de los divs de debug de Liquid
      const debugDivs = document.querySelectorAll('.LOP-debug-handles');
      console.log(`📦 Encontrados ${debugDivs.length} productos con debug info`);
      
      debugDivs.forEach((debugDiv, productIndex) => {
        const productHandle = debugDiv.dataset.product;
        const handlesString = debugDiv.dataset.handles;
        console.log(`\n📌 Producto ${productIndex + 1}: ${productHandle}`);
        console.log(`   Handles raw string: "${handlesString}"`);
        console.log(`   Contenido div:`, debugDiv.textContent.trim());
      });
      
      // Obtener todos los swatches
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const handles = Array.from(swatches).map(swatch => swatch.dataset.productHandle);
      
      console.log(`\n🎨 Total de swatches encontrados: ${swatches.length}`);
      console.log(`📋 Handles completos:`, handles);
      
      // Detectar duplicados
      const handleCounts = {};
      handles.forEach(handle => {
        if (handle) {
          handleCounts[handle] = (handleCounts[handle] || 0) + 1;
        }
      });
      
      const duplicates = Object.entries(handleCounts).filter(([_, count]) => count > 1);
      
      if (duplicates.length > 0) {
        console.warn('\n⚠️ HANDLES DUPLICADOS DETECTADOS:');
        duplicates.forEach(([handle, count]) => {
          console.warn(`   ❌ "${handle}" aparece ${count} veces`);
        });
      } else {
        console.log('\n✅ No se detectaron handles duplicados');
      }
      
      // Analizar cada handle
      console.log('\n📊 Análisis detallado de handles:');
      handles.forEach((handle, index) => {
        if (handle) {
          const cleanHandle = handle.trim();
          const isConcatenated = cleanHandle.length > 50 || 
                                (cleanHandle.includes('short-') && cleanHandle.lastIndexOf('short-') !== cleanHandle.indexOf('short-')) ||
                                (cleanHandle.includes('remera-') && cleanHandle.lastIndexOf('remera-') !== cleanHandle.indexOf('remera-')) ||
                                (cleanHandle.includes('rbk') && cleanHandle.split('rbk').length > 2);
          
          const isDuplicate = handleCounts[cleanHandle] > 1;
          
          console.log(`   ${index + 1}. Handle: "${cleanHandle}"`);
          console.log(`      - Longitud: ${cleanHandle.length} caracteres`);
          console.log(`      - ¿Concatenado?: ${isConcatenated ? '❌ SÍ' : '✅ NO'}`);
          console.log(`      - ¿Duplicado?: ${isDuplicate ? '❌ SÍ (' + handleCounts[cleanHandle] + ' veces)' : '✅ NO'}`);
          
          if (isConcatenated) {
            console.warn(`      ⚠️ Este handle parece estar concatenado!`);
          }
        }
      });
      
      console.log('\n🔍 ===== FIN DEBUG =====\n');
      
      return {
        totalHandles: handles.length,
        uniqueHandles: Object.keys(handleCounts).length,
        duplicates: duplicates.length,
        duplicateDetails: duplicates,
        validHandles: handles.filter(h => h && h.trim().length < 50).length,
        concatenatedHandles: handles.filter(h => h && h.trim().length > 50).length
      };
    }

    /**
     * Verificar formato de metafields desde JavaScript
     */
    debugMetafieldFormatFromJS() {
      console.log('Product Card LOP: Verificando formato de metafields desde JS...');
      
      // Buscar elementos de debug en el DOM
      const debugElements = document.querySelectorAll('[style*="display: none"]');
      let debugInfo = null;
      
      debugElements.forEach(element => {
        if (element.textContent.includes('Debug Agrupador Original:')) {
          debugInfo = element.textContent;
        }
      });
      
      if (debugInfo) {
        console.log('Product Card LOP: Información de debug encontrada:', debugInfo);
        
        // Extraer información específica
        const originalMatch = debugInfo.match(/Debug Agrupador Original: ([^\n]+)/);
        const cleanMatch = debugInfo.match(/Debug Agrupador Clean: ([^\n]+)/);
        const handlesMatch = debugInfo.match(/Debug Handles Encontrados: ([^\n]+)/);
        
        if (originalMatch) {
          console.log('Product Card LOP: Formato original:', originalMatch[1].trim());
        }
        if (cleanMatch) {
          console.log('Product Card LOP: Formato limpio:', cleanMatch[1].trim());
        }
        if (handlesMatch) {
          console.log('Product Card LOP: Handles encontrados:', handlesMatch[1].trim());
        }
      } else {
        console.log('Product Card LOP: No se encontró información de debug en el DOM');
      }
      
      return debugInfo;
    }
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.productCardLOPInstance = new ProductCardLOP();
    });
  } else {
    window.productCardLOPInstance = new ProductCardLOP();
  }

  // Exponer para debugging
  window.ProductCardLOP = ProductCardLOP;
  
  // Función global para debugging
  window.debugProductCardLOP = function() {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debug();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para debug de product cards específicos
  window.debugProductCard = function(productCard) {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debugProductCard(productCard);
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para debug de todos los product cards
  window.debugAllProductCards = function() {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debugAllProductCards();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para verificar productos del agrupador
  window.debugAgrupadorProducts = function(agrupadorString) {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debugAgrupadorProducts(agrupadorString);
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para cargar datos de productos faltantes
  window.loadMissingProductData = function() {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.loadMissingProductData();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para cargar datos de un producto específico
  window.loadProductData = function(handle) {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.loadProductData(handle);
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return Promise.reject('Instancia no encontrada');
    }
  };

  // Función para verificar estado del fallback
  window.debugFallbackStatus = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.debugFallbackStatus();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para verificar estado actual de swatches
  window.checkCurrentSwatchStatus = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.checkCurrentSwatchStatus();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para forzar carga de swatches de fallback
  window.forceLoadAllFallbackSwatches = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.forceLoadAllFallbackSwatches();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para verificar formato de metafields
  window.debugMetafieldFormat = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.debugMetafieldFormat();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para verificar formato de metafields desde JS
  window.debugMetafieldFormatFromJS = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.debugMetafieldFormatFromJS();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para ocultar swatches duplicados
  window.hideDuplicateSwatches = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.hideDuplicateSwatches();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

})(); 
